import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { dateFormat, endpointApi } from '../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../redux/actions/auth.action';
import { useDispatch } from 'react-redux';

export default function SearchOrder({ updateOrder=null, defaultValue=null, required=false, reset=false }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const autocompleteListRef = useRef(null);
    const autocompleteInputRef = useRef(null);
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [q, setQ] = useState("");
    const [order, setOrder] = useState(defaultValue);
    const [orders, setOrders] = useState([]);

    const searchOrders = useCallback(async (q=null) => {
        try {
            const jwt_access = localStorage.getItem('jwt_access');
            const { data } = await axios.get(`${ endpointApi }orders/search${ q ? '?q=' + q : '' }`, {
                headers: {
                    'Authorization': `Bearer ${ jwt_access }`
                }
            });
            setOrders(data);
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
    }, [dispatch, navigate, location]);

    useEffect(() => {
        searchOrders();
    }, [searchOrders, location]);

    useEffect(() => {
        if(reset)
            setIsTouched(false);
    }, [reset]);


    useEffect(() => {
        if(q.length >= 2){
            searchOrders(q);
        }
    }, [searchOrders, q]);
    
    useEffect(() => {
        setQ("");
        if(updateOrder && order){
            updateOrder(order);
        }
    }, [updateOrder, order]);

    useEffect(() => {
        setOrder(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        const clickOutsiteAutocompleteList = (e) => {
            if(autocompleteInputRef.current && e.target !== autocompleteInputRef.current && autocompleteListRef.current && !autocompleteListRef.current.contains(e.target) && autocompleteListRef.current.classList.contains('active')){
                setIsAutocompleteOpen(false);
            }
        }
        document.addEventListener('click', clickOutsiteAutocompleteList);
        return () => {
            document.removeEventListener('click', clickOutsiteAutocompleteList);
        }
    }, []);

    return (
        <>
            <div className='autocomplete'>
                <label htmlFor='order_id' className='form-control'>{ order ? order.code + ", du " + dateFormat(order.order_date) + ", par " + (order.type === "Company" ? order.company_name : order.last_name + " " + order.first_name) : 'Rechercher une commande' }</label>
                <input type='text' id="order_id" ref={ autocompleteInputRef } onFocus={ () => {
                    setIsAutocompleteOpen(true);
                }} placeholder={ order ? order.code + ", du " + dateFormat(order.order_date) + ", par " + (order.type === "Company" ? order.company_name : order.last_name + " " + order.first_name) : 'Rechercher une commande' } className='form-control' value={ q } onChange={ (e) => setQ(e.target.value) } onBlur={ () => setIsTouched(true) } />
                <ul className={ `autocomplete-list${ isAutocompleteOpen ? ' active' : '' }` } ref={ autocompleteListRef }>
                    { orders.map(item => {
                        return(
                            <li key={ item.id } onClick={ () => {
                                setOrder(item);
                                setIsAutocompleteOpen(false);
                            } }><i className='fa fa-search'></i> { item.code + ", du " + dateFormat(item.order_date) + ", par " + (item.type === "Company" ? item.company_name : item.last_name + " " + item.first_name) }</li>
                        )
                    }) }
                    { orders.length === 0 && <li className='empty'>Aucun résultat trouvé</li> }
                </ul>
            </div>
            { isTouched && required && order === null && <div className='form-error'>Veuillez sélectionner la commande.</div> }
        </>
    )
}
